import React, { PureComponent } from 'react';
import iconsStyle from '../../styles/icons.less';
import style from './tooltip.less';
import className from 'classnames';
import _ from '../../i18n.jsx';

export default class Tooltip extends PureComponent {
    constructor() {
        super();
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.state = { open: false };
        document.body.addEventListener('click', this.hideTooltip);
    }

    showTooltip() {
        this.setState({ open: true });
    }
    hideTooltip() {
        if (this.state.open) {
            setTimeout(() => { this.setState({ open: false }); }, 0);
        }
    }
    render() {
        const open = this.state.open;
        const helpText = this.props.helpText;
        const infoIconClassName = className(style.infoHolderIcon, iconsStyle[`icon-info`]);
        const tooltipPopoverClassName = className(style.popover, { [style.hidden]: !open });
        return (
            <span className={style.infoHolder} onClick={this.showTooltip}>
                <em className={infoIconClassName}></em>
                <span>{Tooltip.STRINGS.LABEL}</span>
                { open
                    ? <div className={tooltipPopoverClassName}>
                          <div className={style.arrow}></div>
                          <div className={style.text}>{_(helpText)}</div>
                      </div>
                    : null
                }
            </span>
        );
    }
}

Tooltip.STRINGS = {
    LABEL: _('why are we asking?')
};
